import React, { useState, useRef } from "react";
import { Button, Form, Container, Row, Col } from "react-bootstrap";
import ReporteCamion from "./ReporteCamion";
import API from "../api"; // ✅ Agregado

function NuevoReporteCamion() {
  const [datos, setDatos] = useState({
    dia: "",
    mes: "",
    año: "",
    numero: "",
    maquina: "",
    patente: "",
    kmFinal: "",
    kmInicial: "",
    faena: [
      { tipo: "PETROLEO", cantidad: "" },
      { tipo: "GASOLINA", cantidad: "" },
      { tipo: "ACEITE", cantidad: "" },
      { tipo: "GRASA", cantidad: "" },
    ],
    observaciones: "",
    operador: "",
    jefeObra: "",
  });

  const [reporteGenerado, setReporteGenerado] = useState(null);
  const reporteRef = useRef();

  const handlePrint = () => {
    const printContents = reporteRef.current.innerHTML;
    const logoURL = `${window.location.origin}/movimonte-logo.png`;


    const contentWithFixedLogo = printContents.replace(
      /<img\s+src="[^"]*logo[^"]*"/i,
      `<img src="${logoURL}"`
    );

    const newWindow = window.open("", "_blank", "width=800,height=600");
    newWindow.document.write(`
      <html>
        <head>
          <title>Reporte de Camión</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 40px; }
            table { width: 100%; border-collapse: collapse; }
            td, th { border: 1px solid #000; padding: 6px; text-align: left; }
            h2, h4 { text-align: center; }
            .firma { text-align: center; margin-top: 60px; }
            .firma-box { width: 160px; height: 40px; border-bottom: 1px solid #000; margin: 0 auto 6px; }
            img { width: 100px; }
          </style>
        </head>
        <body>${contentWithFixedLogo}</body>
      </html>
    `);
    newWindow.document.close();

    newWindow.onload = () => {
      const logoImg = newWindow.document.querySelector("img");
      if (logoImg && !logoImg.complete) {
        logoImg.onload = () => {
          newWindow.print();
          newWindow.close();
        };
      } else {
        newWindow.print();
        newWindow.close();
      }
    };
  };

  const actualizarCampo = (campo, valor) => {
    setDatos((prev) => ({ ...prev, [campo]: valor }));
  };

  const actualizarFaena = (index, campo, valor) => {
    const nuevosFluidos = [...datos.faena];
    nuevosFluidos[index][campo] = valor;
    setDatos({ ...datos, faena: nuevosFluidos });
  };

  const generarReporte = async () => {
    const camposObligatorios = [
      "dia", "mes", "año", "numero", "maquina", "patente",
      "kmInicial", "kmFinal", "observaciones", "operador", "jefeObra"
    ];

    const hayVacios = camposObligatorios.some((campo) => !datos[campo].trim());

    if (hayVacios) {
      alert("❌ Complete todos los campos obligatorios.");
      return;
    }

    const tipos = datos.faena.map((f) => f.tipo.trim().toUpperCase());
    const tiposUnicos = new Set(tipos);

    if (tipos.length !== tiposUnicos.size) {
      alert("❌ No se puede ingresar el mismo tipo de producto más de una vez.");
      return;
    }

    try {
      const check = await fetch(`${API}/reportes-camion/existe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...datos,
          fecha: {
            dia: datos.dia,
            mes: datos.mes,
            año: datos.año,
          },
        }),
      });

      const result = await check.json();
      if (result.existe) {
        alert("❌ Este talonario ya está guardado en la base de datos con los mismos datos.");
        return;
      }
    } catch (error) {
      alert("❌ Error verificando duplicado: " + error.message);
      return;
    }

    try {
      const res = await fetch(`${API}/reportes-camion`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...datos,
          fecha: {
            dia: datos.dia,
            mes: datos.mes,
            año: datos.año,
          },
        }),
      });

      if (res.ok) {
        const nuevoReporte = await res.json();
        setReporteGenerado(nuevoReporte.reporte);
        alert("✅ Reporte guardado con éxito");
      } else {
        alert("❌ Error guardando el reporte");
      }
    } catch (error) {
      alert("Error: " + error.message);
    }
  };

  return (
    <Container style={{ maxWidth: 1000, padding: 20 }}>
      <h3 className="mb-4">📋 Nuevo Reporte de Camión</h3>
      <Form>
        <Row>
          <Col>
            <Form.Label>Día</Form.Label>
            <Form.Control value={datos.dia} onChange={(e) => actualizarCampo("dia", e.target.value)} />
          </Col>
          <Col>
            <Form.Label>Mes</Form.Label>
            <Form.Control value={datos.mes} onChange={(e) => actualizarCampo("mes", e.target.value)} />
          </Col>
          <Col>
            <Form.Label>Año</Form.Label>
            <Form.Control value={datos.año} onChange={(e) => actualizarCampo("año", e.target.value)} />
          </Col>
        </Row>

        <Form.Group className="mt-3">
          <Form.Label>Número</Form.Label>
          <Form.Control value={datos.numero} onChange={(e) => actualizarCampo("numero", e.target.value)} />
        </Form.Group>

        <Row className="mt-3">
          <Col>
            <Form.Label>Máquina</Form.Label>
            <Form.Control value={datos.maquina} onChange={(e) => actualizarCampo("maquina", e.target.value)} />
          </Col>
          <Col>
            <Form.Label>Patente</Form.Label>
            <Form.Control value={datos.patente} onChange={(e) => actualizarCampo("patente", e.target.value)} />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col>
            <Form.Label>Kilómetros Inicial</Form.Label>
            <Form.Control value={datos.kmInicial} onChange={(e) => actualizarCampo("kmInicial", e.target.value)} />
          </Col>
          <Col>
            <Form.Label>Kilómetros Final</Form.Label>
            <Form.Control value={datos.kmFinal} onChange={(e) => actualizarCampo("kmFinal", e.target.value)} />
          </Col>
        </Row>

        <h5 className="mt-4">🛢️ Fluidos Aplicados</h5>
        {datos.faena.map((fluido, index) => (
          <Row className="mb-2" key={index}>
            <Col md={6}>
              {fluido.tipo === "GRASA" ? (
                <Form.Select
                  value={fluido.cantidad}
                  onChange={(e) => actualizarFaena(index, "cantidad", e.target.value)}
                >
                  <option value="">¿Aplicó grasa?</option>
                  <option value="Sí">Sí</option>
                  <option value="No">No</option>
                </Form.Select>
              ) : (
                <Form.Control
                  placeholder={`${fluido.tipo} (Lts.)`}
                  value={fluido.cantidad}
                  onChange={(e) => actualizarFaena(index, "cantidad", e.target.value)}
                />
              )}
            </Col>
          </Row>
        ))}

        <Form.Group className="mb-3 mt-3">
          <Form.Label>Observaciones</Form.Label>
          <Form.Control value={datos.observaciones} onChange={(e) => actualizarCampo("observaciones", e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Operador</Form.Label>
          <Form.Control value={datos.operador} onChange={(e) => actualizarCampo("operador", e.target.value)} />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Jefe de Obra</Form.Label>
          <Form.Control value={datos.jefeObra} onChange={(e) => actualizarCampo("jefeObra", e.target.value)} />
        </Form.Group>

        <div className="d-flex gap-3 mt-3">
          <Button variant="primary" onClick={generarReporte}>
            💾 Guardar Reporte
          </Button>
          {reporteGenerado && (
            <Button variant="success" onClick={handlePrint}>
              🖨️ Imprimir / Descargar PDF
            </Button>
          )}
        </div>
      </Form>

      {reporteGenerado && (
        <div className="mt-5" ref={reporteRef}>
          <ReporteCamion datos={reporteGenerado} />
        </div>
      )}
    </Container>
  );
}

export default NuevoReporteCamion;
